// @ts-nocheck
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import DynamicTable from '../../../components/DynamicTable';
import moment from 'moment';
import SelectBox from '../../../components/SelectBox';
import CONSTANTS from '../../../constants';
import { useEvent } from '../../../hooks/useEvent';
import { useUser } from '../../../hooks/useUser';
import { useAsync, useAsyncRetry } from 'react-use';
import { useLabDeployment } from '../../../hooks/useLabDeployment';
import DeleteLabPopup from './DeleteLabPopup';
import deleteIcon from '../../../assets/icons/adminScreen/deleteIcon.svg';

const deploymentStatusList = [
  { _id: '1', name: 'All', value: 'all' },
  { _id: '2', name: 'Pending', value: 'pending' },
  { _id: '3', name: 'Deployed', value: 'deployed' },
  { _id: '4', name: 'Failed', value: 'failed' },
  { _id: '5', name: 'Expired', value: 'expired'},
  { _id: '6', name: 'Destroy Failed', value: 'destroy_failed' }
];

const AdminLabDeployments = () => {
  const [page, setPage] = useState(1);
  const { getAllEvents } = useEvent();
  const { getAllLabDeployments } = useLabDeployment();
  const { getAllUsers } = useUser();
  const [deleteData, setDeleteData] = useState(false);

  const {
    control,
    watch,
    formState: { errors },
  } = useForm();

  const { value: eventListData } = useAsync(() => getAllEvents(), []);
  const { value: usersList } = useAsync(() => getAllUsers(), []);
  const search = watch({ control });
  const { user, event, status } = search;

  useEffect(() => { setPage(1); }, [user, event, status]);

  const { value: labDeploymentList, retry: refreshLabDeployments } = useAsyncRetry(() =>
    getAllLabDeployments({
      page, userId: user?._id, eventId: event?._id, limit: CONSTANTS.PAGE_LIMIT, status: status?.value,
    }),
  [page, user, event, status]);


  const columns = [
    {
      title: 'S. No',
      dataIndex: '_id',
      key: '_id',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Event',
      dataIndex: 'event',
      key: 'event',
      render: (event) => event?.name,
    },
    {
      title: 'Challenge',
      dataIndex: 'challenge',
      key: 'challenge',
      render: (challenge) => challenge?.title,
    },
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
      render: (user) => user?.userName,
    },
    {
      title: 'Deployment Type',
      dataIndex: 'deploymentType',
      key: 'deploymentType',
    },
    {
      title: 'Target Details',
      dataIndex: 'targetDetails',
      key: 'targetDetails',
      render: (targetDetails) => {
        let allTargets = {};
        if (typeof targetDetails === 'string') {
          allTargets = JSON.parse(targetDetails);
        } else {
          allTargets = Object.values(targetDetails || {}).flat();
        }
        return (
          <ul>
            {allTargets.length > 0 && allTargets.map(target => (
              <li>{target}</li>
            ))}
          </ul>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Deployed On',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => moment(createdAt).format('DD-MM-YYYY, h:mm a'),
    },
    {
      title: 'Expiry',
      dataIndex: 'expiry',
      key: 'expiry',
      render: (expiry) => moment(expiry).format('DD-MM-YYYY, h:mm a'),
    },
    {
      title: 'Action',
      dataIndex: '',
      key: '',
      render: (data) => (
        <div className="justify-start items-center gap-4 flex">
          {!['expired'].includes(data.status) ? (
            <div
              className="justify-start items-center gap-1.5 flex cursor-pointer"
              onClick={() => { setDeleteData(data); }}
            >
              <div className="w-4 h-4 relative">
                <img src={deleteIcon} alt="icon" />
              </div>
              <div className="text-sky-600 text-sm font-medium font-['Manrope'] leading-normal">Destroy Lab</div>
            </div>
          ) : (
            <div>N/A</div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="w-full h-auto flex-col justify-start items-start gap-8 inline-flex p-8">
      {deleteData && (
        <DeleteLabPopup
          deleteData={deleteData}
          setDeleteData={setDeleteData}
          refreshLabDeployments={refreshLabDeployments}
        />
      )}
      <div className="self-stretch justify-start items-start gap-8 grid grid-cols-12">
        <div
          className="col-span-12 grow shrink basis-0 self-stretch p-6 bg-white rounded-lg flex-col
            justify-center items-start gap-4 inline-flex"
        >
          <form autoComplete="off" className="w-full">
            <div className="grid grid-cols-12 gap-6 w-full">
              <div className="col-span-4">
                <SelectBox
                  name="user"
                  placeholder="User"
                  options={usersList?.users || []}
                  label="Select User"
                  control={control}
                  errors={errors}
                  customLabel="userName"
                  customValue="_id"
                  customHeight="40px"
                  isClearable
                  customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope']"
                />
              </div>
              <div className="col-span-5">
                <SelectBox
                  name="event"
                  placeholder="Event Name"
                  options={eventListData?.events || []}
                  label="Select Event"
                  control={control}
                  errors={errors}
                  customLabel="name"
                  customValue="_id"
                  customHeight="40px"
                  isClearable
                  customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope']"
                />
              </div>
              <div className="col-span-3">
                <SelectBox
                  name="status"
                  placeholder="Deployment Status"
                  options={deploymentStatusList || []}
                  label="Select Deployment Status"
                  control={control}
                  errors={errors}
                  customLabel="name"
                  customValue="_id"
                  customHeight="40px"
                  defaultInputValue={deploymentStatusList[0]}
                  customWidth="full"
                  isClearable={false}
                  customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope']"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="self-stretch h-auto w-full p-6 bg-white rounded-lg flex-col justify-start items-start flex">
        <DynamicTable
          dataList={labDeploymentList?.labDeployments}
          columns={columns}
          totalCount={labDeploymentList?.totalLabDeployments}
          pageSize={CONSTANTS.PAGE_LIMIT}
          onPageChange={setPage}
          currentPage={page}
        />
      </div>
    </div>
  );
};

export default AdminLabDeployments;
